import React from "react";
import { CustomersActionHandlerProps } from "./action-types";
import ExportCustomers from "./export-customer";
import AddToCampaignModal from "./add-new-campaign/add-new-campiagn";
import MassConvert from "./mass-convert";
import MassUpdateOfCustomers from "./mass-update/customer-mass-update";
import MassDeleteOfCustomers from "./mass-delete/customer-mass-delete";


const CustomerActionHandler: React.FC<CustomersActionHandlerProps> = (
    {
        selectedCustomersMap,
        setSelectedCustomersMap,
        selectedActions,
        setSelectedActions,
        menuItems,
        setMenuItems,
        fetchCustomers,
        selectedCustomerActionScope,
        setselectedCustomerActionScope,
        totalRecords,
        handleMassActionMenuClose,
        leadsData,
    }
) => {
    const fetchIsOpen = (action: string) => {
        return menuItems.find((item) => item.value === action)?.isOpen || false;
    }

    return (
        <div className="lead-action-handler">
            <MassUpdateOfCustomers
                customerIds={Object.values(selectedCustomersMap).flat() || []}
                isOpen={fetchIsOpen("Update")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                fetchCustomers={fetchCustomers}
                totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
                setSelectedCustomersMap={setSelectedCustomersMap}
            />
            <MassDeleteOfCustomers
                customerIds={Object.values(selectedCustomersMap).flat() || []}
                isOpen={fetchIsOpen("Archive")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                fetchCustomers={fetchCustomers}
                setSelectedCustomersMap={setSelectedCustomersMap}
                totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
            />
             {/* <MassConvert
                customerIds={Object.values(selectedCustomersMap).flat() || []}
                isOpen={fetchIsOpen("Convert")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                setSelectedActions={setSelectedActions}
                fetchCustomers={fetchCustomers}
                selectedCustomerActionScope={selectedCustomerActionScope}
                setselectedCustomerActionScope={setselectedCustomerActionScope}
                totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
                setSelectedCustomersMap={setSelectedCustomersMap}
                leadsData={leadsData}
            /> */}
            <ExportCustomers
                customerIds={Object.values(selectedCustomersMap).flat() || []}
                isOpen={fetchIsOpen("Export Customers")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                fetchCustomers={fetchCustomers}
                handleMassActionMenuClose={handleMassActionMenuClose}
                setSelectedCustomersMap={setSelectedCustomersMap}
            />
            <AddToCampaignModal
                customerIds={Object.values(selectedCustomersMap).flat() || []}
                isOpen={fetchIsOpen("Add to Campaigns")}
                setMenuItems={setMenuItems}
                selectedActions={selectedActions}
                // setSelectedActions={setSelectedActions}
                // fetchCustomers={fetchCustomers}
                // selectedCustomerActionScope={selectedCustomerActionScope}
                // setselectedCustomerActionScope={setselectedCustomerActionScope}
                // totalRecords={totalRecords}
                handleMassActionMenuClose={handleMassActionMenuClose}
            // setSelectedCustomersMap={setSelectedCustomersMap}
            />
        </div>
    )
}

export default CustomerActionHandler;